import { css } from 'styled-components';
import { mediaBreakpoint } from '@services/responsiveProvider';

export const table = css`
  width: 100%;
  display: grid;
  align-items: center;
  grid-column-gap: 10px;
  grid-template-columns: 3fr repeat(4, 1fr);
  ${mediaBreakpoint.mobile} {
    grid-template-columns: 1fr 1fr;
    grid-row-gap: 10px;
    grid-template-areas:
      "title title"
      "gender distance"
      "ageRange price";
  }
`;
